import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Dropdown } from 'react-bootstrap';
import AdminTemplateList from './AdminTemplateList';
import templateService from '../../../services/template.service';
import Loading from '../../common/Loading';
const STAT_CONFIG = [
    { key: 'email', label: 'Email', icon: 'bi-envelope', iconClass: 'admin-templates-stat__icon--email' },
    { key: 'sms', label: 'SMS', icon: 'bi-chat-dots', iconClass: 'admin-templates-stat__icon--sms' },
    { key: 'call', label: 'Call', icon: 'bi-telephone', iconClass: 'admin-templates-stat__icon--call' },
    { key: 'total', label: 'Total', icon: 'bi-collection', iconClass: 'admin-templates-stat__icon--total' },
];

const AdminTemplateDashboard = () => {
    const navigate = useNavigate();
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);
    const [templateCounts, setTemplateCounts] = useState({
        email: 0,
        sms: 0,
        call: 0,
        total: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTemplateCounts = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await templateService.getEcxTemplate(0, 1000);
                const templates = response.data.content || [];

                setTemplateCounts({
                    email: templates.filter((t) => t.mediumType === 'EMAIL').length,
                    sms: templates.filter((t) => t.mediumType === 'SMS').length,
                    call: templates.filter((t) => t.mediumType === 'CALL').length,
                    total: templates.length,
                });
            } catch (err) {
                console.error('Error fetching template counts:', err);
                setError('Failed to load template statistics.');
            } finally {
                setLoading(false);
            }
        };

        fetchTemplateCounts();
    }, []);

    const handleCreateTemplate = (mediumType) => {
        navigate(`/admin-templates/${mediumType.toLowerCase()}`);
    };

    if (loading) {
        return (
            <div className="container-fluid px-3 px-lg-4">
                <div className="pagetitle">
                    <h1>
                        <i className="bi bi-file-earmark-medical"></i> Admin Templates
                    </h1>
                </div>
                <Loading />
            </div>
        );
    }

    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-file-earmark-medical"></i> Admin Templates
                </h1>
                <Dropdown className="admin-templates-create-menu">
                    <Dropdown.Toggle variant="outline-primary" size="sm" id="dropdown-create-template">
                        <i className="bi bi-plus-lg me-1"></i>
                        Create Template
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                        <Dropdown.Item onClick={() => handleCreateTemplate('EMAIL')}>
                            <i className="bi bi-envelope text-primary me-2"></i>
                            Email Template
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleCreateTemplate('SMS')}>
                            <i className="bi bi-chat-dots text-success me-2"></i>
                            SMS Template
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleCreateTemplate('CALL')}>
                            <i className="bi bi-telephone text-info me-2"></i>
                            Call Template
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            {error && (
                <div className="alert alert-warning border-0 shadow-sm mb-3">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    {error}
                </div>
            )}

            <Card className="admin-templates-card shadow-sm border-0">
                <Card.Body className="p-3">
                    <div className="admin-templates-stat-grid">
                        {STAT_CONFIG.map((stat) => (
                            <div key={stat.key} className="admin-templates-stat">
                                <div className="admin-templates-stat__info">
                                    <div className="admin-templates-stat__value">
                                        {templateCounts[stat.key]}
                                    </div>
                                    <div className="admin-templates-stat__label">{stat.label}</div>
                                </div>
                                <span className={`admin-templates-stat__icon ${stat.iconClass}`}>
                                    <i className={`bi ${stat.icon}`}></i>
                                </span>
                            </div>
                        ))}
                    </div>

                    <AdminTemplateList
                        searchPanelOpen={searchPanelOpen}
                        onSearchPanelToggle={() => setSearchPanelOpen((open) => !open)}
                        onCreateTemplate={handleCreateTemplate}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default AdminTemplateDashboard;
